import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/api';
import './Profile.css';

const Profile = () => {
    const { user } = useAuth();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [showPasswordForm, setShowPasswordForm] = useState(false);

    const [passwordData, setPasswordData] = useState({
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
    });

    const handlePasswordChange = (e) => {
        setPasswordData({
            ...passwordData,
            [e.target.name]: e.target.value
        });
        setError('');
        setSuccess('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        // Validations
        if (!passwordData.currentPassword || !passwordData.newPassword || !passwordData.confirmPassword) {
            setError('Por favor complete todos los campos');
            return;
        }

        if (passwordData.newPassword.length < 8) {
            setError('La nueva contraseña debe tener al menos 8 caracteres');
            return;
        }

        if (passwordData.newPassword !== passwordData.confirmPassword) {
            setError('Las contraseñas no coinciden');
            return;
        }

        if (passwordData.currentPassword === passwordData.newPassword) {
            setError('La nueva contraseña debe ser diferente a la actual');
            return;
        }

        try {
            setLoading(true);
            const response = await authService.changePassword(
                passwordData.currentPassword,
                passwordData.newPassword
            );

            if (response.success) {
                setSuccess('Contraseña cambiada exitosamente');
                setPasswordData({
                    currentPassword: '',
                    newPassword: '',
                    confirmPassword: ''
                });
                setShowPasswordForm(false);

                // Show success message for 3 seconds
                setTimeout(() => {
                    setSuccess('');
                }, 3000);
            }
        } catch (err) {
            setError(err.response?.data?.message || 'Error al cambiar la contraseña');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="profile-container">
            <div className="page-header">
                <h1>Mi Perfil</h1>
                <div className="page-header-actions">
                    <button className="btn btn-primary" onClick={() => navigate('/dashboard')}>
                        ← Volver al Dashboard
                    </button>
                </div>
            </div>

            <div className="profile-content">
                {/* User Information Card */}
                <div className="profile-card">
                    <h2>Información Personal</h2>
                    <div className="profile-info">
                        <div className="info-row">
                            <span className="info-label">Nombre:</span>
                            <span className="info-value">{user?.firstName} {user?.lastName}</span>
                        </div>
                        <div className="info-row">
                            <span className="info-label">Email:</span>
                            <span className="info-value">{user?.email}</span>
                        </div>
                        <div className="info-row">
                            <span className="info-label">Rol:</span>
                            <span className="info-value role-badge">
                                {user?.role === 'medico' && 'Médico'}
                                {user?.role === 'administrador' && 'Administrador'}
                                {user?.role === 'recepcionista' && 'Recepcionista'}
                                {user?.role === 'paciente' && 'Paciente'}
                            </span>
                        </div>
                        {user?.phone && (
                            <div className="info-row">
                                <span className="info-label">Teléfono:</span>
                                <span className="info-value">{user.phone}</span>
                            </div>
                        )}
                    </div>
                </div>

                {/* Change Password Card */}
                <div className="profile-card">
                    <div className="card-header">
                        <h2>Seguridad</h2>
                        {!showPasswordForm && (
                            <button
                                className="btn btn-secondary"
                                onClick={() => setShowPasswordForm(true)}
                            >
                                Cambiar Contraseña
                            </button>
                        )}
                    </div>

                    {showPasswordForm && (
                        <form onSubmit={handleSubmit} className="password-form">
                            {error && <div className="alert alert-error">{error}</div>}
                            {success && <div className="alert alert-success">{success}</div>}

                            <div className="form-group">
                                <label>Contraseña Actual *</label>
                                <input
                                    type="password"
                                    name="currentPassword"
                                    value={passwordData.currentPassword}
                                    onChange={handlePasswordChange}
                                    required
                                    disabled={loading}
                                />
                            </div>

                            <div className="form-group">
                                <label>Nueva Contraseña *</label>
                                <input
                                    type="password"
                                    name="newPassword"
                                    value={passwordData.newPassword}
                                    onChange={handlePasswordChange}
                                    required
                                    disabled={loading}
                                    minLength="8"
                                />
                                <small className="form-hint">Mínimo 8 caracteres</small>
                            </div>

                            <div className="form-group">
                                <label>Confirmar Nueva Contraseña *</label>
                                <input
                                    type="password"
                                    name="confirmPassword"
                                    value={passwordData.confirmPassword}
                                    onChange={handlePasswordChange}
                                    required
                                    disabled={loading}
                                />
                            </div>

                            <div className="form-actions">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => {
                                        setShowPasswordForm(false);
                                        setPasswordData({
                                            currentPassword: '',
                                            newPassword: '',
                                            confirmPassword: ''
                                        });
                                        setError('');
                                        setSuccess('');
                                    }}
                                    disabled={loading}
                                >
                                    Cancelar
                                </button>
                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={loading}
                                >
                                    {loading ? 'Cambiando...' : 'Cambiar Contraseña'}
                                </button>
                            </div>
                        </form>
                    )}

                    {!showPasswordForm && (
                        <p className="security-info">
                            Es recomendable cambiar su contraseña temporal por una de su elección.
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Profile;
